import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'
import { MultiSelect } from 'legacy/lut/library/multiSelect'
import React, { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'
import { Checkbox } from 'core-components/library/checkbox'
import { Textarea } from 'core-components/library/inputs'
import { Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'
import { GeoMapping, IPbmListItem } from 'partner360/components/filters'
import { TRANSLATION_KEYS } from 'partner360/components/QBR/translations'
import { selectQBRRtm } from 'partner360/features/QBR'

import { IApplyFilter } from '../models'

import styles from './FilterArea.module.scss'

interface IFilterAreaProps {
  onApply: (args: IApplyFilter) => void
}

export const FilterArea = ({ onApply }: IFilterAreaProps) => {
  const [isSetMyPartnersFilter, setIsSetMyPartnersFilter] = useState(true)
  const [geoValues, setGeoValues] = useState<string[]>([])
  const [pbms, setPbms] = useState<string[]>([])
  const [partnerIds, setPartnerIds] = useState('')
  const rtm = useSelector(selectQBRRtm)

  const pbmCrud = CrudStore.get(CrudStoreItemPartner360.JBPPBMs) as Crud<IPbmListItem>

  const isDisableApplyFilterButton = useMemo(() => {
    return !isSetMyPartnersFilter && !geoValues.length && !pbms.length && !partnerIds.length
  }, [geoValues, isSetMyPartnersFilter, partnerIds, pbms])

  const onChangeGeoMapping = useCallback((displayedIds: string[]) => {
    setGeoValues(displayedIds)
  }, [])

  const pbmsSource = useMemo(() => {
    pbmCrud.setDefaultFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'RTM',
          operator: Operator.EQUAL,
          value: rtm,
        },
      ],
    })

    return pbmCrud
  }, [rtm, pbmCrud])

  const onReset = useCallback(() => {
    setIsSetMyPartnersFilter(true)
    setGeoValues([])
    setPbms([])
    setPartnerIds('')
  }, [])

  const applyClickHandle = useCallback(() => {
    onApply({ geoValues, partnerIds, pbms, isSetMyPartnersFilter })
  }, [geoValues, isSetMyPartnersFilter, onApply, partnerIds, pbms])

  return (
    <div className={styles.root}>
      <Checkbox
        checked={isSetMyPartnersFilter}
        onChange={setIsSetMyPartnersFilter}
        label={<Translation text={TRANSLATION_KEYS.addPartnersModal.filter.myPartnersCheckbox} />}
        margin={'md'}
      />
      <div className={styles.fields}>
        <GeoMapping
          className={styles.fields__field}
          values={geoValues}
          label={<Translation text={TRANSLATION_KEYS.addPartnersModal.filter.geo} />}
          onSelectChange={onChangeGeoMapping}
        />
        <MultiSelect
          classes={{
            controlClasses: {
              root: styles.fields__field,
            },
          }}
          value={pbms}
          source={pbmsSource}
          label="PBM"
          caption={'Email'}
          onChange={setPbms}
        />
      </div>
      <div className={styles.wrapper}>
        <Textarea
          classes={{
            root: styles.wrapper__textArea,
          }}
          value={partnerIds}
          label={<Translation text={TRANSLATION_KEYS.addPartnersModal.filter.pids} />}
          onChange={setPartnerIds}
        />
        <div className={styles.wrapper__btns}>
          <Button onClick={applyClickHandle} disabled={isDisableApplyFilterButton}>
            <Translation text={TRANSLATION_KEYS.addPartnersModal.filter.applyFilter} />
          </Button>
          <Button color="grey" onClick={onReset}>
            <Translation text={TRANSLATION_KEYS.addPartnersModal.filter.clearFilter} />
          </Button>
        </div>
      </div>
    </div>
  )
}
